import {
	Autocomplete,
	Box,
	Button,
	Container,
	CssBaseline,
	Grid,
	TextField,
	Typography,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import useGenerateGuideContainerStyles from './GenerateGuideContainer.styles';
interface data {
	codigo_remision: string;
	id_proceso: string;
	identificacionRemitente: string;
	nombreRemitente: string;
	telefonoRemitente: string;
	correoRemitente: string;
	direccionRemitente: string;
	ciudadRemitente: {
		id: string;
		name: string;
	};
	identificacionDestinatario: string;
	nombreDestinatario: string;
	telefonoDestinatario: string;
	correoDestinatario: string;
	direccionDestinatario: string;
	ciudadDestinatario: {
		id: string;
		name: string;
	};
	valor_declarado: number;
	codigo_producto: string;
	nivel_servicio: {
		id: string;
		name: string;
	};
	contenido: string;
	observaciones: string;
	estado: string;
	ubl: number;
	alto: number;
	ancho: number;
	largo: number;
	peso: number;
	referencia: string;
	unidades: number;
	nombre_empaque: string;
}
const GenerateGuideContainer: React.FC = () => {
	const classes = useGenerateGuideContainerStyles();
	const {
		handleSubmit,
		control,
		register,
		formState: { errors },
	} = useForm<data>();
	const onSubmit = (data: data) => {
		console.log(data);
	};
	return (
		<div className={classes.root}>
			<CssBaseline />
			<Container maxWidth="lg">
				<Box className={classes.box}>
					<div className={classes.containerTitle}>
						<h2>Generar guia</h2>
					</div>
					<div>
						<form onSubmit={handleSubmit(onSubmit)} noValidate>
							<div style={{ width: '90%', margin: 'auto' }}>
								<Grid container spacing={1}>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Código de remisión
										</Typography>
										<TextField
											fullWidth
											{...register('codigo_remision', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.codigo_remision?.message}
											error={Boolean(errors.codigo_remision?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Id Proceso
										</Typography>
										<TextField
											fullWidth
											{...register('id_proceso', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.id_proceso?.message}
											error={Boolean(errors.id_proceso?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Identificación del Remitente
										</Typography>
										<TextField
											fullWidth
											{...register('identificacionRemitente', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.identificacionRemitente?.message}
											error={Boolean(errors.identificacionRemitente?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Nombre del Remitente
										</Typography>
										<TextField
											fullWidth
											{...register('nombreRemitente', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.nombreRemitente?.message}
											error={Boolean(errors.nombreRemitente?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Telefono del Remitente
										</Typography>
										<TextField
											fullWidth
											{...register('telefonoRemitente', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.telefonoRemitente?.message}
											error={Boolean(errors.telefonoRemitente?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Correo del Remitente
										</Typography>
										<TextField
											fullWidth
											{...register('correoRemitente', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
												pattern: {
													value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
													message: 'Correo no válido.',
												},
											})}
											helperText={errors.correoRemitente?.message}
											error={Boolean(errors.correoRemitente?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Dirección del Remitente
										</Typography>
										<TextField
											fullWidth
											{...register('direccionRemitente', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.direccionRemitente?.message}
											error={Boolean(errors.direccionRemitente?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Ciudad del Remitente
										</Typography>
										<Controller
											control={control}
											name="ciudadRemitente"
											rules={{
												required: 'Campo requerido',
											}}
											render={({
												field: { onChange, value },
												fieldState,
											}) => (
												<Autocomplete
													options={[
														{
															id: '11001000',
															name: 'Bogota',
														},
														{
															id: '05001000',
															name: 'Medellín',
														},
														{
															id: '76001000',
															name: 'Cali',
														},
													]}
													getOptionLabel={(option) => option.name}
													value={value}
													onChange={(
														_,
														cit: {
															id: string;
															name: string;
														} | null
													) => {
														onChange(cit);
													}}
													style={{ marginTop: 8, marginBottom: 15 }}
													renderInput={(params) => (
														<TextField
															{...params}
															size="small"
															error={!!fieldState.error}
															helperText={fieldState.error?.message}
														/>
													)}
												/>
											)}
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Identificación del Destinatario
										</Typography>
										<TextField
											fullWidth
											{...register('identificacionDestinatario', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.identificacionDestinatario?.message}
											error={Boolean(
												errors.identificacionDestinatario?.message
											)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Nombre del Destinatario
										</Typography>
										<TextField
											fullWidth
											{...register('nombreDestinatario', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.nombreDestinatario?.message}
											error={Boolean(errors.nombreDestinatario?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Telefono del Destinatario
										</Typography>
										<TextField
											fullWidth
											{...register('telefonoDestinatario', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.telefonoDestinatario?.message}
											error={Boolean(errors.telefonoDestinatario?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Correo del Destinatario
										</Typography>
										<TextField
											fullWidth
											{...register('correoDestinatario', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
												pattern: {
													value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
													message: 'Correo no válido.',
												},
											})}
											helperText={errors.correoDestinatario?.message}
											error={Boolean(errors.correoDestinatario?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Dirección del Destinatario
										</Typography>
										<TextField
											fullWidth
											{...register('direccionDestinatario', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.direccionDestinatario?.message}
											error={Boolean(errors.direccionDestinatario?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Ciudad del Destinatario
										</Typography>
										<Controller
											control={control}
											name="ciudadDestinatario"
											rules={{
												required: 'Campo requerido',
											}}
											render={({
												field: { onChange, value },
												fieldState,
											}) => (
												<Autocomplete
													options={[
														{
															id: '11001000',
															name: 'Bogota',
														},
														{
															id: '05001000',
															name: 'Medellín',
														},
														{
															id: '76001000',
															name: 'Cali',
														},
													]}
													getOptionLabel={(option) => option.name}
													value={value}
													onChange={(
														_,
														cit: {
															id: string;
															name: string;
														} | null
													) => {
														onChange(cit);
													}}
													style={{ marginTop: 8, marginBottom: 15 }}
													renderInput={(params) => (
														<TextField
															{...params}
															size="small"
															error={!!fieldState.error}
															helperText={fieldState.error?.message}
														/>
													)}
												/>
											)}
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Valor Declarado
										</Typography>
										<TextField
											fullWidth
											{...register('valor_declarado', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.valor_declarado?.message}
											error={Boolean(errors.valor_declarado?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="number"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Código del Producto
										</Typography>
										<TextField
											fullWidth
											{...register('codigo_producto', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.codigo_producto?.message}
											error={Boolean(errors.codigo_producto?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Niveles de Servicio
										</Typography>
										<Controller
											control={control}
											name="nivel_servicio"
											rules={{
												required: 'Campo requerido',
											}}
											render={({
												field: { onChange, value },
												fieldState,
											}) => (
												<Autocomplete
													options={[
														{
															id: '1',
															name: 'estandar',
														},
														{
															id: '2',
															name: 'Express',
														},
														{
															id: '6',
															name: 'Logística de Reversa Loterías',
														},
														{
															id: '9',
															name: 'Retorno Loterias',
														},
														{
															id: '10',
															name: 'Radicacion de Documentos',
														},
														{
															id: '22',
															name: 'Recaudos Contra Entrega',
														},
													]}
													getOptionLabel={(option) => option.name}
													value={value}
													onChange={(
														_,
														niv: {
															id: string;
															name: string;
														} | null
													) => {
														onChange(niv);
													}}
													style={{ marginTop: 8, marginBottom: 15 }}
													renderInput={(params) => (
														<TextField
															{...params}
															size="small"
															error={!!fieldState.error}
															helperText={fieldState.error?.message}
														/>
													)}
												/>
											)}
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Contenido
										</Typography>
										<TextField
											fullWidth
											{...register('contenido', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.contenido?.message}
											error={Boolean(errors.contenido?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={12}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Observaciones
										</Typography>
										<TextField
											fullWidth
											{...register('observaciones', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.observaciones?.message}
											error={Boolean(errors.observaciones?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Estado
										</Typography>
										<TextField
											fullWidth
											{...register('estado', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.estado?.message}
											error={Boolean(errors.estado?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Ubl
										</Typography>
										<TextField
											fullWidth
											{...register('ubl', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.ubl?.message}
											error={Boolean(errors.ubl?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="number"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Alto
										</Typography>
										<TextField
											fullWidth
											{...register('alto', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.alto?.message}
											error={Boolean(errors.alto?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="number"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Ancho
										</Typography>
										<TextField
											fullWidth
											{...register('ancho', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.ancho?.message}
											error={Boolean(errors.ancho?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="number"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Largo
										</Typography>
										<TextField
											fullWidth
											{...register('largo', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.largo?.message}
											error={Boolean(errors.largo?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="number"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Peso
										</Typography>
										<TextField
											fullWidth
											{...register('peso', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.peso?.message}
											error={Boolean(errors.peso?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="number"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Referencia
										</Typography>
										<TextField
											fullWidth
											{...register('referencia', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.referencia?.message}
											error={Boolean(errors.referencia?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Unidades
										</Typography>
										<TextField
											fullWidth
											{...register('unidades', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.unidades?.message}
											error={Boolean(errors.unidades?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="number"
										/>
									</Grid>
									<Grid item xs={4}>
										<Typography
											color="#707070"
											fontFamily="Montserrat"
											fontSize={14}
											fontWeight={500}
										>
											Nombre empaque
										</Typography>
										<TextField
											fullWidth
											{...register('nombre_empaque', {
												required: {
													value: true,
													message: 'Campo requerido.',
												},
											})}
											helperText={errors.nombre_empaque?.message}
											error={Boolean(errors.nombre_empaque?.message)}
											size="small"
											style={{ marginTop: 8, marginBottom: 15 }}
											type="text"
										/>
									</Grid>
								</Grid>
							</div>
							<div style={{ textAlign: 'center', padding: 10 }}>
								<Button
									style={{
										background: '#003C82',
										fontFamily: 'Montserrat',
										color: 'white',
										padding: '8px 26px',
										fontSize: 12,
										borderRadius: 10,
									}}
									type="submit"
								>
									Generar guía
								</Button>
							</div>
						</form>
					</div>
				</Box>
			</Container>
		</div>
	);
};
export default GenerateGuideContainer;
